export * from './ResponsesView';


// WEBPACK FOOTER //
// ./src/components/responses/index.tsx